export default __webpack_public_path__ + "static/media/empty_state_search.a9aa174f.png";